/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as OnboardingPendingRouteImport } from './routes/onboarding-pending'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as HqRouteImport } from './routes/hq'
import { Route as WorkspaceRouteImport } from './routes/$workspace'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspacesIndexRouteImport } from './routes/workspaces.index'
import { Route as WorkspaceIndexRouteImport } from './routes/$workspace.index'
import { Route as WorkspacesNewRouteImport } from './routes/workspaces.new'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as WorkspaceTimelineRouteImport } from './routes/$workspace.timeline'
import { Route as WorkspaceSignalsRouteImport } from './routes/$workspace.signals'
import { Route as WorkspaceSettingsRouteImport } from './routes/$workspace.settings'
import { Route as WorkspaceScenariosRouteImport } from './routes/$workspace.scenarios'
import { Route as WorkspaceScenarioTreeRouteImport } from './routes/$workspace.scenario-tree'
import { Route as WorkspaceRiskRouteImport } from './routes/$workspace.risk'
import { Route as WorkspaceOntologiesRouteImport } from './routes/$workspace.ontologies'
import { Route as WorkspaceNetworkRouteImport } from './routes/$workspace.network'
import { Route as WorkspaceHypothesesRouteImport } from './routes/$workspace.hypotheses'
import { Route as WorkspaceGeographicRouteImport } from './routes/$workspace.geographic'
import { Route as WorkspaceFlowRouteImport } from './routes/$workspace.flow'
import { Route as WorkspaceEntitiesRouteImport } from './routes/$workspace.entities'
import { Route as WorkspaceDevicesRouteImport } from './routes/$workspace.devices'
import { Route as WorkspaceDecisionsRouteImport } from './routes/$workspace.decisions'
import { Route as WorkspaceDataRouteImport } from './routes/$workspace.data'
import { Route as WorkspaceChatRouteImport } from './routes/$workspace.chat'
import { Route as WorkspaceDecisionsIndexRouteImport } from './routes/$workspace.decisions.index'
import { Route as WorkspaceDecisionsDecisionIdRouteImport } from './routes/$workspace.decisions.$decisionId'

const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPendingRoute = OnboardingPendingRouteImport.update({
  id: '/onboarding-pending',
  path: '/onboarding-pending',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const HqRoute = HqRouteImport.update({
  id: '/hq',
  path: '/hq',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/$workspace',
  path: '/$workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIndexRoute = WorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceIndexRoute = WorkspaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspacesNewRoute = WorkspacesNewRouteImport.update({
  id: '/workspaces/new',
  path: '/workspaces/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceTimelineRoute = WorkspaceTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSignalsRoute = WorkspaceSignalsRouteImport.update({
  id: '/signals',
  path: '/signals',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceSettingsRoute = WorkspaceSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceScenariosRoute = WorkspaceScenariosRouteImport.update({
  id: '/scenarios',
  path: '/scenarios',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceScenarioTreeRoute = WorkspaceScenarioTreeRouteImport.update({
  id: '/scenario-tree',
  path: '/scenario-tree',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceRiskRoute = WorkspaceRiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceOntologiesRoute = WorkspaceOntologiesRouteImport.update({
  id: '/ontologies',
  path: '/ontologies',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceNetworkRoute = WorkspaceNetworkRouteImport.update({
  id: '/network',
  path: '/network',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceHypothesesRoute = WorkspaceHypothesesRouteImport.update({
  id: '/hypotheses',
  path: '/hypotheses',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceGeographicRoute = WorkspaceGeographicRouteImport.update({
  id: '/geographic',
  path: '/geographic',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceFlowRoute = WorkspaceFlowRouteImport.update({
  id: '/flow',
  path: '/flow',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceEntitiesRoute = WorkspaceEntitiesRouteImport.update({
  id: '/entities',
  path: '/entities',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDevicesRoute = WorkspaceDevicesRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDecisionsRoute = WorkspaceDecisionsRouteImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDataRoute = WorkspaceDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceChatRoute = WorkspaceChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => WorkspaceRoute,
} as any)
const WorkspaceDecisionsIndexRoute = WorkspaceDecisionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkspaceDecisionsRoute,
} as any)
const WorkspaceDecisionsDecisionIdRoute =
  WorkspaceDecisionsDecisionIdRouteImport.update({
    id: '/$decisionId',
    path: '/$decisionId',
    getParentRoute: () => WorkspaceDecisionsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$workspace': typeof WorkspaceRouteWithChildren
  '/hq': typeof HqRoute
  '/onboarding': typeof OnboardingRoute
  '/onboarding-pending': typeof OnboardingPendingRoute
  '/settings': typeof SettingsRoute
  '/team': typeof TeamRoute
  '/$workspace/chat': typeof WorkspaceChatRoute
  '/$workspace/data': typeof WorkspaceDataRoute
  '/$workspace/decisions': typeof WorkspaceDecisionsRouteWithChildren
  '/$workspace/devices': typeof WorkspaceDevicesRoute
  '/$workspace/entities': typeof WorkspaceEntitiesRoute
  '/$workspace/flow': typeof WorkspaceFlowRoute
  '/$workspace/geographic': typeof WorkspaceGeographicRoute
  '/$workspace/hypotheses': typeof WorkspaceHypothesesRoute
  '/$workspace/network': typeof WorkspaceNetworkRoute
  '/$workspace/ontologies': typeof WorkspaceOntologiesRoute
  '/$workspace/risk': typeof WorkspaceRiskRoute
  '/$workspace/scenario-tree': typeof WorkspaceScenarioTreeRoute
  '/$workspace/scenarios': typeof WorkspaceScenariosRoute
  '/$workspace/settings': typeof WorkspaceSettingsRoute
  '/$workspace/signals': typeof WorkspaceSignalsRoute
  '/$workspace/timeline': typeof WorkspaceTimelineRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/workspaces/new': typeof WorkspacesNewRoute
  '/$workspace/': typeof WorkspaceIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/$workspace/decisions/$decisionId': typeof WorkspaceDecisionsDecisionIdRoute
  '/$workspace/decisions/': typeof WorkspaceDecisionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/hq': typeof HqRoute
  '/onboarding': typeof OnboardingRoute
  '/onboarding-pending': typeof OnboardingPendingRoute
  '/settings': typeof SettingsRoute
  '/team': typeof TeamRoute
  '/$workspace/chat': typeof WorkspaceChatRoute
  '/$workspace/data': typeof WorkspaceDataRoute
  '/$workspace/devices': typeof WorkspaceDevicesRoute
  '/$workspace/entities': typeof WorkspaceEntitiesRoute
  '/$workspace/flow': typeof WorkspaceFlowRoute
  '/$workspace/geographic': typeof WorkspaceGeographicRoute
  '/$workspace/hypotheses': typeof WorkspaceHypothesesRoute
  '/$workspace/network': typeof WorkspaceNetworkRoute
  '/$workspace/ontologies': typeof WorkspaceOntologiesRoute
  '/$workspace/risk': typeof WorkspaceRiskRoute
  '/$workspace/scenario-tree': typeof WorkspaceScenarioTreeRoute
  '/$workspace/scenarios': typeof WorkspaceScenariosRoute
  '/$workspace/settings': typeof WorkspaceSettingsRoute
  '/$workspace/signals': typeof WorkspaceSignalsRoute
  '/$workspace/timeline': typeof WorkspaceTimelineRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/workspaces/new': typeof WorkspacesNewRoute
  '/$workspace': typeof WorkspaceIndexRoute
  '/workspaces': typeof WorkspacesIndexRoute
  '/$workspace/decisions/$decisionId': typeof WorkspaceDecisionsDecisionIdRoute
  '/$workspace/decisions': typeof WorkspaceDecisionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$workspace': typeof WorkspaceRouteWithChildren
  '/hq': typeof HqRoute
  '/onboarding': typeof OnboardingRoute
  '/onboarding-pending': typeof OnboardingPendingRoute
  '/settings': typeof SettingsRoute
  '/team': typeof TeamRoute
  '/$workspace/chat': typeof WorkspaceChatRoute
  '/$workspace/data': typeof WorkspaceDataRoute
  '/$workspace/decisions': typeof WorkspaceDecisionsRouteWithChildren
  '/$workspace/devices': typeof WorkspaceDevicesRoute
  '/$workspace/entities': typeof WorkspaceEntitiesRoute
  '/$workspace/flow': typeof WorkspaceFlowRoute
  '/$workspace/geographic': typeof WorkspaceGeographicRoute
  '/$workspace/hypotheses': typeof WorkspaceHypothesesRoute
  '/$workspace/network': typeof WorkspaceNetworkRoute
  '/$workspace/ontologies': typeof WorkspaceOntologiesRoute
  '/$workspace/risk': typeof WorkspaceRiskRoute
  '/$workspace/scenario-tree': typeof WorkspaceScenarioTreeRoute
  '/$workspace/scenarios': typeof WorkspaceScenariosRoute
  '/$workspace/settings': typeof WorkspaceSettingsRoute
  '/$workspace/signals': typeof WorkspaceSignalsRoute
  '/$workspace/timeline': typeof WorkspaceTimelineRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/workspaces/new': typeof WorkspacesNewRoute
  '/$workspace/': typeof WorkspaceIndexRoute
  '/workspaces/': typeof WorkspacesIndexRoute
  '/$workspace/decisions/$decisionId': typeof WorkspaceDecisionsDecisionIdRoute
  '/$workspace/decisions/': typeof WorkspaceDecisionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$workspace'
    | '/hq'
    | '/onboarding'
    | '/onboarding-pending'
    | '/settings'
    | '/team'
    | '/$workspace/chat'
    | '/$workspace/data'
    | '/$workspace/decisions'
    | '/$workspace/devices'
    | '/$workspace/entities'
    | '/$workspace/flow'
    | '/$workspace/geographic'
    | '/$workspace/hypotheses'
    | '/$workspace/network'
    | '/$workspace/ontologies'
    | '/$workspace/risk'
    | '/$workspace/scenario-tree'
    | '/$workspace/scenarios'
    | '/$workspace/settings'
    | '/$workspace/signals'
    | '/$workspace/timeline'
    | '/auth/callback'
    | '/workspaces/new'
    | '/$workspace/'
    | '/workspaces/'
    | '/$workspace/decisions/$decisionId'
    | '/$workspace/decisions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/hq'
    | '/onboarding'
    | '/onboarding-pending'
    | '/settings'
    | '/team'
    | '/$workspace/chat'
    | '/$workspace/data'
    | '/$workspace/devices'
    | '/$workspace/entities'
    | '/$workspace/flow'
    | '/$workspace/geographic'
    | '/$workspace/hypotheses'
    | '/$workspace/network'
    | '/$workspace/ontologies'
    | '/$workspace/risk'
    | '/$workspace/scenario-tree'
    | '/$workspace/scenarios'
    | '/$workspace/settings'
    | '/$workspace/signals'
    | '/$workspace/timeline'
    | '/auth/callback'
    | '/workspaces/new'
    | '/$workspace'
    | '/workspaces'
    | '/$workspace/decisions/$decisionId'
    | '/$workspace/decisions'
  id:
    | '__root__'
    | '/'
    | '/$workspace'
    | '/hq'
    | '/onboarding'
    | '/onboarding-pending'
    | '/settings'
    | '/team'
    | '/$workspace/chat'
    | '/$workspace/data'
    | '/$workspace/decisions'
    | '/$workspace/devices'
    | '/$workspace/entities'
    | '/$workspace/flow'
    | '/$workspace/geographic'
    | '/$workspace/hypotheses'
    | '/$workspace/network'
    | '/$workspace/ontologies'
    | '/$workspace/risk'
    | '/$workspace/scenario-tree'
    | '/$workspace/scenarios'
    | '/$workspace/settings'
    | '/$workspace/signals'
    | '/$workspace/timeline'
    | '/auth/callback'
    | '/workspaces/new'
    | '/$workspace/'
    | '/workspaces/'
    | '/$workspace/decisions/$decisionId'
    | '/$workspace/decisions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
  HqRoute: typeof HqRoute
  OnboardingRoute: typeof OnboardingRoute
  OnboardingPendingRoute: typeof OnboardingPendingRoute
  SettingsRoute: typeof SettingsRoute
  TeamRoute: typeof TeamRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  WorkspacesNewRoute: typeof WorkspacesNewRoute
  WorkspacesIndexRoute: typeof WorkspacesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding-pending': {
      id: '/onboarding-pending'
      path: '/onboarding-pending'
      fullPath: '/onboarding-pending'
      preLoaderRoute: typeof OnboardingPendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hq': {
      id: '/hq'
      path: '/hq'
      fullPath: '/hq'
      preLoaderRoute: typeof HqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspace': {
      id: '/$workspace'
      path: '/$workspace'
      fullPath: '/$workspace'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/': {
      id: '/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof WorkspacesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspace/': {
      id: '/$workspace/'
      path: '/'
      fullPath: '/$workspace/'
      preLoaderRoute: typeof WorkspaceIndexRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/workspaces/new': {
      id: '/workspaces/new'
      path: '/workspaces/new'
      fullPath: '/workspaces/new'
      preLoaderRoute: typeof WorkspacesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$workspace/timeline': {
      id: '/$workspace/timeline'
      path: '/timeline'
      fullPath: '/$workspace/timeline'
      preLoaderRoute: typeof WorkspaceTimelineRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/signals': {
      id: '/$workspace/signals'
      path: '/signals'
      fullPath: '/$workspace/signals'
      preLoaderRoute: typeof WorkspaceSignalsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/settings': {
      id: '/$workspace/settings'
      path: '/settings'
      fullPath: '/$workspace/settings'
      preLoaderRoute: typeof WorkspaceSettingsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/scenarios': {
      id: '/$workspace/scenarios'
      path: '/scenarios'
      fullPath: '/$workspace/scenarios'
      preLoaderRoute: typeof WorkspaceScenariosRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/scenario-tree': {
      id: '/$workspace/scenario-tree'
      path: '/scenario-tree'
      fullPath: '/$workspace/scenario-tree'
      preLoaderRoute: typeof WorkspaceScenarioTreeRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/risk': {
      id: '/$workspace/risk'
      path: '/risk'
      fullPath: '/$workspace/risk'
      preLoaderRoute: typeof WorkspaceRiskRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/ontologies': {
      id: '/$workspace/ontologies'
      path: '/ontologies'
      fullPath: '/$workspace/ontologies'
      preLoaderRoute: typeof WorkspaceOntologiesRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/network': {
      id: '/$workspace/network'
      path: '/network'
      fullPath: '/$workspace/network'
      preLoaderRoute: typeof WorkspaceNetworkRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/hypotheses': {
      id: '/$workspace/hypotheses'
      path: '/hypotheses'
      fullPath: '/$workspace/hypotheses'
      preLoaderRoute: typeof WorkspaceHypothesesRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/geographic': {
      id: '/$workspace/geographic'
      path: '/geographic'
      fullPath: '/$workspace/geographic'
      preLoaderRoute: typeof WorkspaceGeographicRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/flow': {
      id: '/$workspace/flow'
      path: '/flow'
      fullPath: '/$workspace/flow'
      preLoaderRoute: typeof WorkspaceFlowRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/entities': {
      id: '/$workspace/entities'
      path: '/entities'
      fullPath: '/$workspace/entities'
      preLoaderRoute: typeof WorkspaceEntitiesRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/devices': {
      id: '/$workspace/devices'
      path: '/devices'
      fullPath: '/$workspace/devices'
      preLoaderRoute: typeof WorkspaceDevicesRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/decisions': {
      id: '/$workspace/decisions'
      path: '/decisions'
      fullPath: '/$workspace/decisions'
      preLoaderRoute: typeof WorkspaceDecisionsRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/data': {
      id: '/$workspace/data'
      path: '/data'
      fullPath: '/$workspace/data'
      preLoaderRoute: typeof WorkspaceDataRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/chat': {
      id: '/$workspace/chat'
      path: '/chat'
      fullPath: '/$workspace/chat'
      preLoaderRoute: typeof WorkspaceChatRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/$workspace/decisions/': {
      id: '/$workspace/decisions/'
      path: '/'
      fullPath: '/$workspace/decisions/'
      preLoaderRoute: typeof WorkspaceDecisionsIndexRouteImport
      parentRoute: typeof WorkspaceDecisionsRoute
    }
    '/$workspace/decisions/$decisionId': {
      id: '/$workspace/decisions/$decisionId'
      path: '/$decisionId'
      fullPath: '/$workspace/decisions/$decisionId'
      preLoaderRoute: typeof WorkspaceDecisionsDecisionIdRouteImport
      parentRoute: typeof WorkspaceDecisionsRoute
    }
  }
}

interface WorkspaceDecisionsRouteChildren {
  WorkspaceDecisionsDecisionIdRoute: typeof WorkspaceDecisionsDecisionIdRoute
  WorkspaceDecisionsIndexRoute: typeof WorkspaceDecisionsIndexRoute
}

const WorkspaceDecisionsRouteChildren: WorkspaceDecisionsRouteChildren = {
  WorkspaceDecisionsDecisionIdRoute: WorkspaceDecisionsDecisionIdRoute,
  WorkspaceDecisionsIndexRoute: WorkspaceDecisionsIndexRoute,
}

const WorkspaceDecisionsRouteWithChildren =
  WorkspaceDecisionsRoute._addFileChildren(WorkspaceDecisionsRouteChildren)

interface WorkspaceRouteChildren {
  WorkspaceChatRoute: typeof WorkspaceChatRoute
  WorkspaceDataRoute: typeof WorkspaceDataRoute
  WorkspaceDecisionsRoute: typeof WorkspaceDecisionsRouteWithChildren
  WorkspaceDevicesRoute: typeof WorkspaceDevicesRoute
  WorkspaceEntitiesRoute: typeof WorkspaceEntitiesRoute
  WorkspaceFlowRoute: typeof WorkspaceFlowRoute
  WorkspaceGeographicRoute: typeof WorkspaceGeographicRoute
  WorkspaceHypothesesRoute: typeof WorkspaceHypothesesRoute
  WorkspaceNetworkRoute: typeof WorkspaceNetworkRoute
  WorkspaceOntologiesRoute: typeof WorkspaceOntologiesRoute
  WorkspaceRiskRoute: typeof WorkspaceRiskRoute
  WorkspaceScenarioTreeRoute: typeof WorkspaceScenarioTreeRoute
  WorkspaceScenariosRoute: typeof WorkspaceScenariosRoute
  WorkspaceSettingsRoute: typeof WorkspaceSettingsRoute
  WorkspaceSignalsRoute: typeof WorkspaceSignalsRoute
  WorkspaceTimelineRoute: typeof WorkspaceTimelineRoute
  WorkspaceIndexRoute: typeof WorkspaceIndexRoute
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceChatRoute: WorkspaceChatRoute,
  WorkspaceDataRoute: WorkspaceDataRoute,
  WorkspaceDecisionsRoute: WorkspaceDecisionsRouteWithChildren,
  WorkspaceDevicesRoute: WorkspaceDevicesRoute,
  WorkspaceEntitiesRoute: WorkspaceEntitiesRoute,
  WorkspaceFlowRoute: WorkspaceFlowRoute,
  WorkspaceGeographicRoute: WorkspaceGeographicRoute,
  WorkspaceHypothesesRoute: WorkspaceHypothesesRoute,
  WorkspaceNetworkRoute: WorkspaceNetworkRoute,
  WorkspaceOntologiesRoute: WorkspaceOntologiesRoute,
  WorkspaceRiskRoute: WorkspaceRiskRoute,
  WorkspaceScenarioTreeRoute: WorkspaceScenarioTreeRoute,
  WorkspaceScenariosRoute: WorkspaceScenariosRoute,
  WorkspaceSettingsRoute: WorkspaceSettingsRoute,
  WorkspaceSignalsRoute: WorkspaceSignalsRoute,
  WorkspaceTimelineRoute: WorkspaceTimelineRoute,
  WorkspaceIndexRoute: WorkspaceIndexRoute,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  WorkspaceRoute: WorkspaceRouteWithChildren,
  HqRoute: HqRoute,
  OnboardingRoute: OnboardingRoute,
  OnboardingPendingRoute: OnboardingPendingRoute,
  SettingsRoute: SettingsRoute,
  TeamRoute: TeamRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  WorkspacesNewRoute: WorkspacesNewRoute,
  WorkspacesIndexRoute: WorkspacesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
